/**
 * `Intl.NumberFormat` helpers, ported from Base UI's `utils/formatNumber.ts`.
 * The formatter is cached keyed by `JSON.stringify({ locale, options })` so we
 * don't allocate a new `Intl.NumberFormat` on every render/parse.
 */

const cache = new Map<string, Intl.NumberFormat>()

export function getFormatter(locale?: Intl.LocalesArgument, options?: Intl.NumberFormatOptions) {
  const optionsString = JSON.stringify({ locale, options })
  const cachedFormatter = cache.get(optionsString)

  if (cachedFormatter) {
    return cachedFormatter
  }

  const formatter = new Intl.NumberFormat(locale as string | string[] | undefined, options)
  cache.set(optionsString, formatter)

  return formatter
}

export function formatNumber(
  value: number | null,
  locale?: Intl.LocalesArgument,
  options?: Intl.NumberFormatOptions,
): string {
  if (value == null) {
    return ''
  }
  return getFormatter(locale, options).format(value)
}

export function formatNumberMaxPrecision(
  value: number | null,
  locale?: Intl.LocalesArgument,
  options?: Intl.NumberFormatOptions,
): string {
  return formatNumber(value, locale, {
    ...options,
    maximumFractionDigits: 20,
  })
}
